/**
 * language
 */

const lang = {
  unknown: { key: 'unknown', value: 0, label: 'unknown', ojVal: 'G++' },
  c: { key: 'c', value: 1, label: 'c', ojVal: 'GCC' },
  cpp: { key: 'cpp', value: 2, label: 'c ++', ojVal: 'G++' },
  py: { key: 'py', value: 3, label: 'python', ojVal: 'Python3' },
};

export default lang;
